import "@/App.css";
import { Toaster } from "@/components/ui/sonner";
import { Navbar } from "@/components/sections/Navbar";
import { Hero } from "@/components/sections/Hero";
import { About } from "@/components/sections/About";
import { Products } from "@/components/sections/Products";
import { WhyPartner } from "@/components/sections/WhyPartner";
import { Founder } from "@/components/sections/Founder";
import { Contact } from "@/components/sections/Contact";
import { Footer } from "@/components/sections/Footer";

function App() {
  return (
    <div className="App min-h-screen bg-[#020617] text-white overflow-x-hidden" data-testid="app-root">
      <Navbar />
      <main>
        <Hero />
        <About />
        <Products />
        <WhyPartner />
        <Founder />
        <Contact />
      </main>
      <Footer />
      <Toaster position="top-right" richColors theme="dark" />
    </div>
  );
}

export default App;
